import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Cinematic%20warm%20atmosphere%20with%20abstract%20geometric%20shapes%20in%20orange%20and%20amber%20tones%2C%20soft%20gradient%20background%2C%20modern%20streaming%20platform%20aesthetic%2C%20clean%20minimal%20design%2C%20professional%20website%20hero%20backdrop%2C%20elegant%20dark%20warm%20texture&width=1800&height=900&seq=hero-bg-main&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 mb-6">
          <i className="ri-sparkling-2-line text-primary-300 text-sm w-4 h-4 flex items-center justify-center"></i>
          <span className="text-primary-200 text-xs font-medium whitespace-nowrap">官方正版入口 · 安全稳定可靠</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-4 max-w-3xl leading-tight">
          畅享极致视频体验
        </h1>
        <p className="text-sm md:text-base text-background-200/90 mb-8 max-w-xl leading-relaxed">
          蘑菇视频官网为您提供最新影视、综艺、短视频内容，海量高清视频免费观看，
          支持手机、平板、电视多端同步，随时随地畅享精彩内容
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/dianying"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-play-circle-fill w-5 h-5 flex items-center justify-center"></i>
            立即观看
          </Link>
          <a
            href="/about"
            className="px-8 py-3 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/20 text-background-50 text-sm font-medium hover:bg-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-download-2-line w-5 h-5 flex items-center justify-center"></i>
            下载App
          </a>
        </div>

        <div className="flex items-center gap-8 mt-10">
          {[
            { value: '5000万+', label: '日活用户' },
            { value: '100万+', label: '视频内容' },
            { value: '9.2', label: '用户评分' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-2xl font-heading text-background-50">{stat.value}</div>
              <div className="text-xs text-background-300 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-background-50/30 flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 rounded-full bg-background-50/60 animate-bounce" />
        </div>
      </div>
    </section>
  );
}